
import { downloadBasket } from '@/expressway-api/baskets.api'
import { defineComponent, ref } from 'vue'
import Spinner from '@/components/Spinner.vue'
import { setSnackbar } from '@/composables/useSnackbar'

export default defineComponent({
  components: { Spinner },
  props: {
    // Checkout holds a live basket of its own; everywhere else a booking is
    // named by the reference the API issued for it. Exactly one applies.
    basketId: {
      type: String,
      default: ''
    },
    bookingRef: {
      type: String,
      default: ''
    }
  },
  setup (props) {
    const loading = ref(false)

    const download = () => {
      loading.value = true
      downloadBasket(props.bookingRef || props.basketId).then(response => {
        const link = document.createElement('a')
        link.href = `data:application/octet-stream;base64,${response.data}`
        link.setAttribute('download', 'Expressway Ticket.pdf')
        document.body.appendChild(link)
        link.click()
      }).catch(() => setSnackbar('Error downloading tickets'))
        .finally(() => { loading.value = false })
    }

    return {
      download,
      loading
    }
  }
})
